import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { selectUserId, selectWork, selectWorks } from '../../../../Api/selectors';
import styled from 'styled-components';
import {
  INTERIOR_PREVIEW_VALUES,
  EXTERIOR_PREVIEW_VALUES,
  REQUEST_VEHICLE_PROPERTY_UPDATE,
  REQUEST_VEHICLE,
  REQUEST_VEHICLE_TASKS,
  REQUEST_VEHICLE_ADD_TO_OUTGOING_ORDER,
} from '../../../constants';
import { VBox, HBox } from '../../../../../components/Box';
import { VehicleInfoCard } from '../../../components/CardInfo';
import { VehicleDataCard } from '../../../components/CardData';
import { VehicleFinanceSalesCard } from '../../../components/CardFinanceSales';
import { VehicleCardCounters } from '../../../components/CardCounters';
import { VehicleFinancePurchaseCard } from '../../../components/CardFinancePurchase';
import { VehicleDocumentsCard } from '../../../components/CardDocuments';
import { VehicleLocationCard } from '../../../components/VehicleLocationCard';
import { Card } from '../../../../../components/Card';
import { Button } from '../../../../../components/Buttons';
import { VehicleBpmCard } from '../../../components/CardBPM';
import { Slider } from '../../../components/Slider';
import { VehicleDataConsumptionCard } from '../../../components/ConsumptionEnviromentData';
import { VehicleRDWandHistoryDataCard } from '../../../components/RDWandHistoryCard';
import { VehicleLabelCard } from '../../../components/CardLabel';
import { VehicleTransportCard } from '../../../components/CardTransport';
//import { VehicleHooicardtakeout } from '../components/cardHooicardtakeout';

import { VehicleExtraCostCard } from '../../../components/CardExtraCost';
import { Check, IsOpen } from '../../../../../components/Icon';
import { VehicleOutgoingInvoiceCard } from '../../../components/CardOutgoingInvoice';
import {
  deleteVehicle,
  deleteVehicleProperty,
  downloadImages,
  fetchVehicle,
  fetchVehicleTasks,
  setVehicleProperty,
} from '../../../actions';
import { VehicleWebsiteCard } from '../../../components/CardWebsite';
import { VehicleInspectionCard } from '../../../components/VehicleInspectionCard';
import { Loader } from '../../../../../components/Loader';
import { VehicleTasksCard } from '../../../components/CardVehicleTasks';
import { VehicleInvoicesCard } from '../../../components/VehcleInvoicesCard';
import { fetchVehicleInvoices } from '../../../../Invoices/actions';
import { REQUEST_VEHICLE_INVOICES } from '../../../../Invoices/constants';
//import { VehicleHooiInstallationPhotoCard } from '../components/CardHooiInstallationPhotos';
import { VehicleRemarksCard } from '../../../components/CardVehicleRemarks';
import env from '../../../../../env';
import { VehicleClaimCard } from '../../../components/CardClaim';
import { Permission } from '../../../../../components/Permission';
import {
  VEHICLE_REMOVE,
  VEHICLE_EDIT,
  VEHICLE_INVOICES_BUTTON,
  VEHICLE_DETAILS_BUTTON,
  VEHICLE_DOWNLOAD_IMAGES,
  VEHICLE_ACTIONS_BUTTON,
  VEHICLE_HEXON_BUTTON,
  VEHICLE_TAKEN_BUTTON,
  VEHICLE_LOGS,
  VEHICLE_EXTRA_COSTS_CRUD,
  VEHICLE_TRANSPORT_CRUD,
  VEHICLE_INSPECTION_CRUD,
  VEHICLE_DOCUMENTS_CRUD,
  PURCHASING_DATA_CRUD,
  SALES_DATA_CRUD,
  INVOICES_PAGE,
  DEP_FINANCE,
  DEP_COMMERCE,
  DEP_WALSTREET,
  DEP_ADMINISTRATION,
  DEP_IT,
  DEP_WORKSHOP,
  DEP_ADMIN,
  DEP_TRANSPORT,
  VEHICLE_CREATE,
} from '../../../../../components/Permission/constants';
import { VehicleOptionsCard } from '../../../components/VehicleOptionsCard';
import { AppClientId } from '../../../../Shared/constants';
import { SaleAgreementPdfPreview } from '../../../components/SaleAgreement/SaleAgreementPdfPreview';
import { EditVehicleOptions } from '../../../pages/create/OptionsStep/EditVehicleOptions';
import { PdfPreview } from '../../../components/PriceCardPDF/PdfPreview';
import cn from 'classnames';
import styles from './detailsColumns.module.css';
import LoadingDetailsPageCard from '../../../../../containers/App/Components/LoadingDetailsPageCard/LoadingDetailsPageCard';
import { NewAndNotUsed } from '../../../components/NewAndNotUsedPDF/NewAndNotUsed';
import { VehicleRecommendationCard } from '../../../components/RecommendationCard';
import { DebitorVehicleCard } from '../../../components/DebitorVehicleCard';
import { VehicleTransportOrderCard } from '../../../components/CardVehicleTransportOrder';
import { VehicleProductTasksSection } from '../../../components/VehicleProductTasksSection';
import {
  APPLY_TRANSPORT_ORDER_FILTERS,
  REQUEST_TRANSPORT_ORDER_FILTER,
  REQUEST_TRANSPORT_ORDERS,
} from '../../../../TransportOrders/constants';
import { VehicleOutgoingProductInvoiceCard } from '../../../components/CardProductOutgoingInvoice';
import { VehicleInspectionCardv2 } from '../../../components/VehicleInspectionCardv2';
import { VehicleTasksRemarksCard } from '../../../components/CardVehicleTasksRemarks';
import { LoadScriptNext } from '@react-google-maps/api';
import LoadingCard from '../../../../../containers/App/Components/LoadingCard/LoadingCard';
import { CopyVehicleModal } from '../../../components/CopyVehicle/CopyVehicleModal';
import { IDWE_quality_check_commerce } from '../../../../KanbanBoards/cells/WS/IDWE_quality_check_commerce';
import { KanbanRemarksCard } from '../../../components/KanbanRemarksCard';

//comment1
const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 100%;
  }
  .info-card {
    min-width: 260px;
    width: 100%;
    margin: 5px 0;
    // border: 1px solid #dbdcdc;
    // box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.07); /* Grey box shadow */
  }
  .info-card.wide {
    width: 99%;
  }

  .info-card-fin {
    min-width: 260px;
    width: 100%;
    margin: 5px 0;
    // border: 1px solid #dbdcdc;
    // box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.07); /* Grey box shadow */
  }
  .info-card-fin.wide {
    width: 99%;
  }

  .vehicle-info-card info-card {
    &.misc {
      .button {
        margin: 2px;
        background-color: #ddd;
        color: #333;
      }
    }
  }

  .vbox .toggleBtn {
    margin-left: auto;
    width: 12%;
  }

  .slider-block {
    background-color: #fff;
    min-width: 260px;
    width: 100%;
    margin: 5px 0;
    border: 0px solid #dbdcdc;
    box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.07);
  }

  .vbox.col {
    width: auto;

    @media (max-width: 768px) {
      width: 100%;
    }
  }
`;

const Wrapper = styled.div`
  // display: flex;
  // flex-direction: row;
  // justify-content: space-between;
  display: grid;
  grid-template-columns: 49% 49%;
  gap: 10px;
  width: 100%;

  @media (max-width: 1440px) {
    gap: 5px;
    width: 100%;
  }

  @media (max-width: 768px) {
    display: grid;
    flex-direction: column;
    justify-content: center;

    & > div {
      width: 100%;
    }
  }
`;
const STATE = {
  previewType: 'exterior',
  isShowExsterior: true,
  isShow: true,
  loading: false,
  IsOpen: false,
  showSaleAgreementPdfPreview: false,
  showCopyVehicleModal: false,
};

class VehicleDetailsColumnsComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.timeout(() => this.setState({ showOutgoingInvoiceCard: true }), 1500);
    this.timeout(() => this.setState({ loadSliderAfterTimeout: true }), 800);
    this.timeout(this.props.fetchVehicleTasks, 2000);
    this.setOutgoingProductInvoiceCardData();
  }

  get vehicle() {
    return this.props.vehicle;
  }

  getActionIdByName(name) {
    return this.props.actions?.find(a => a.functionName === name)?.id ?? null;
  }

  renderActionModal() {
    return (
      <IDWE_quality_check_commerce
        vehicleDetails
        cell={{ vehicle: this.props.vehicle }}
        action={{ label: 'label', id: this.getActionIdByName('IDWE_quality_check_commerce') }}
        payload={{ task_name: 'task_spray' }}
        column={{ label: 'Quality Check' }}
        loggedUserId={this.props.loggedInUser}
      />
    );
  }

  setOutgoingProductInvoiceCardData() {
    this.props.fetchVehicleInvoices(result => {
      if (result?.items?.length > 0) {
        console.log('Fetched Invoices:', result.items);

        const outgoingProductInvoices = result.items.filter(invoice => {
          const isOutgoing = invoice?.direction === 'outgoing';
          const isProduct = invoice?.subjectType === 'product';
          const isNotFinal = !invoice?.isFinal;

          console.log(
            `Invoice ID: ${invoice.id}, isOutgoing: ${isOutgoing}, isProduct: ${isProduct}, isNotFinal: ${isNotFinal}`,
          );

          return isOutgoing && isProduct && isNotFinal;
        });
        console.log('outgoingProductInvoices', outgoingProductInvoices);
        console.log('Filtered outgoing product invoices:', outgoingProductInvoices);

        if (outgoingProductInvoices.length > 0) {
          const lastCreatedOutgoingProductId = outgoingProductInvoices[0]?.id;
          this.setState({ outgoingProductInvoiceId: lastCreatedOutgoingProductId });
        }
      }
    });
  }

  hideBlock(val) {
    this.setState({ loading: true });
    return this.setState(prev => ({ ...prev, previewType: 'exterior', isShow: val, loading: false }));
  }

  hideExteriorBlock(val) {
    this.setState({ loading: true });
    return this.setState(prev => ({ ...prev, isShowExsterior: val, loading: false }));
  }

  handleDelete = () => {
    // eslint-disable-next-line no-alert, no-restricted-globals
    if (!confirm('delete vehicle?')) return;
    this.props.deleteVehicle(result => {
      if (result) {
        console.log(result, 'RES');
        return this.to('/');
      }
    });
  };

  handleCopy = () => {
    this.setState({ showCopyVehicleModal: true });
  };

  downloadImages() {
    this.setState({ downloadingImages: true }, () => {
      this.props.downloadImages(result => {
        this.setState({ downloadingImages: false });
        window.open('/storage/zip/tmp/' + this.props.vehicle.id + '.zip');
      });
    });
  }

  renderThirdColumn() {
    const vehicle = this.props.vehicle;
    return (
      <>
        <VehicleLabelCard vehicle={this.props.vehicle} />

        <VehicleDocumentsCard vehicle={this.props.vehicle} />

        <VehicleLocationCard vehicle={this.props.vehicle} vehicle_details />

        <Card className={cn('vehicle-info-card info-card misc', styles.card)}>
          <h2 className="card-title mb-2 text-muted">other</h2>
          <Permission permission={VEHICLE_EDIT}>
            <div className={styles.containerButton}>
              <Button className={styles.buttonEdit} primary onClick={this.tofn(`/vehicles/${this.vehicle.id}/edit`)}>
                {this.lbl('edit')}
              </Button>
            </div>
          </Permission>
          {/* <Button onClick={this.tofn(`/vehicles/${this.vehicle.id}`)}>{this.lbl('vehicle.details.columns.title')}</Button> */}
          {vehicle.status !== '3' ? (
            <div className={styles.containerButton}>
              <Button
                className={styles.button}
                onClick={() => window.open(`https://inspectie.indewal.nl/vindat/vehicles/${this.vehicle.id}`)}
              >
                Inspectie rapport
              </Button>
            </div>
          ) : (
            <div className={styles.containerButton}>
              <Button
                className={styles.button}
                onClick={() =>
                  window.open(
                    `https://inspectie.indewal.nl/vindat/vehicles/${this.vehicle.id}?token=${vehicle.creditor_company}`,
                  )
                }
              >
                Inspectie rapport
              </Button>
            </div>
          )}
          {vehicle.status !== '3' ? (
            <div className={styles.containerButton}>
              <Button
                className={styles.button}
                onClick={() => window.open(`https://inspectie.indewal.nl/vindat/vehicles/${this.vehicle.id}?version1`)}
              >
                Inspectie rapport V1
              </Button>
            </div>
          ) : (
            <div className={styles.containerButton}>
              <Button
                className={styles.button}
                onClick={() =>
                  window.open(
                    `https://inspectie.indewal.nl/vindat/vehicles/${this.vehicle.id}?version1&token=${vehicle.creditor_company}`,
                  )
                }
              >
                Inspectie rapport V1
              </Button>
            </div>
          )}
          {window.innerWidth > 768 && (
            <>
              <Button
                onClick={() => {
                  this.setState({ showNewAndNotUsed: true });
                }}
              >
                {this.lbl('vehicle.details.options.NewAndNotUsed')}
              </Button>
              <Permission permission={DEP_IT}>
                <Button onClick={this.tofn(`/vehicles/${this.vehicle.id}/inspection2`)}>Inspectie rapport pdf</Button>
                <Button onClick={this.tofn(`/vehicles/${this.vehicle.id}/carcollect`)}>Carcollect</Button>

                <Button onClick={this.tofn(`/vehicles/${this.vehicle.id}/oreh`)}>OREH Export</Button>
              </Permission>
              {/* <Button onClick={this.tofn(`/vehicles/${this.vehicle.id}`)}>{this.lbl('vehicle.details.columns.title')}</Button> */}

              <Button
                onClick={() => {
                  this.setState({ showSaleAgreementPdfPreview: true });
                }}
              >
                {this.lbl('vehicle.details.documents.fields.purchase_agreement')}
              </Button>
              <Permission permission={DEP_IT}>
                <div className={styles.containerButton}>
                  <Button className={styles.button} onClick={() => this.props.print()}>
                    {this.props.vehicle.label_printer_queue == '2'
                      ? this.lbl('vehicle.property.label_printer_queue.label_printed')
                      : this.lbl('vehicle.property.label_printer_queue.print_label')}{' '}
                  </Button>
                </div>
              </Permission>

              <Permission permission={VEHICLE_DETAILS_BUTTON}>
                <div className={styles.containerButton}>
                  <Button className={styles.button} onClick={this.tofn(`/vehicles/${this.vehicle.id}/legacy`)}>
                    {this.lbl('vehicle.details.title')}
                  </Button>
                </div>
              </Permission>
              {/* <Button onClick={this.tofn(`/vehicles/${this.vehicle.id}/options`)}>
             {this.lbl('vehicle.details.options.title')}
             </Button> */}
              {/* <Button onClick={this.tofn(`/vehicles/${this.vehicle.id}/documents`)}>
             {this.lbl('vehicle.details.documents.title')}
             </Button>
             <Button onClick={this.tofn(`/vehicles/${this.vehicle.id}/price`)}>
             {this.lbl('vehicle.details.price.title')}
             </Button>
             <Button onClick={this.tofn(`/vehicles/${this.vehicle.id}/supplier`)}>
             {this.lbl('vehicle.details.supplier.title')}
             </Button> */}
              <Permission permission={VEHICLE_INVOICES_BUTTON}>
                <div className={styles.containerButton}>
                  <Button className={styles.button} onClick={this.tofn(`/vehicles/${this.vehicle.id}/invoices`)}>
                    {this.lbl('vehicle.details.invoices.title')}
                  </Button>
                </div>
              </Permission>

              <Permission permission={DEP_IT}>
                <Button onClick={this.tofn(`/vehicles/${this.vehicle.id}/actions`)}>actions</Button>
              </Permission>
              {/*
             <Permission permission={VEHICLE_TAKEN_BUTTON}>
                <Button onClick={this.tofn(`/vehicles/${this.vehicle.id}/state`)}>Taken</Button>
             </Permission>
             */}
              <Permission permission={VEHICLE_HEXON_BUTTON}>
                <div className={styles.containerButton}>
                  <Button className={styles.button} onClick={this.tofn(`/vehicles/${this.vehicle.id}/hexon`)}>
                    Hexon
                  </Button>
                </div>
              </Permission>
              <Permission permission={DEP_IT}>
                <div className={styles.containerButton}>
                  <div className={styles.containerButton}></div>
                  <Button
                    className={styles.button}
                    onClick={() => window.open(`/vehicles/${this.vehicle.id}/silverdat`, '_blank')}
                  >
                    Silverdat
                  </Button>
                </div>
              </Permission>
            </>
          )}
          <Permission permission={VEHICLE_DOWNLOAD_IMAGES}>
            <div className={styles.containerButton}>
              <Button
                className={styles.button}
                disabled={this.state.downloadingImages}
                onClick={this.downloadImages.bind(this)}
              >
                {this.state.downloadingImages ? <Loader small /> : null} {this.lbl('vehicle.download-images')}
              </Button>
            </div>
          </Permission>
          <Permission permission={VEHICLE_LOGS}>
            <div className={styles.containerButton}>
              <Button className={styles.button} onClick={this.tofn(`/vehicles/${this.vehicle.id}/history`)}>
                Logs
              </Button>
            </div>
          </Permission>
          {/* {env.enable_hemex ? <Button onClick={this.tofn(`/vehicles/${this.vehicle.id}/hemex`)}>Hemex</Button> : null} */}
          {env.clientId === AppClientId.INDEWAL ? (
            <Permission permission={DEP_IT}>
              <>
                <div className={styles.containerButton}>
                  <Button
                    className={styles.button}
                    active={this.vehicle.special_customer}
                    onClick={() => {
                      this.props.setVehicleProperty('special_customer', this.vehicle.special_customer == '1' ? null : '1');
                    }}
                  >
                    {this.vehicle.special_customer ? <Check /> : null}&nbsp;Special customer
                  </Button>
                </div>
              </>
            </Permission>
          ) : null}
          <Permission permission={VEHICLE_CREATE}>
            <div className={styles.containerButton}>
              <Button className={styles.button} onClick={this.handleCopy}>
                Copy vehicle
              </Button>
            </div>
          </Permission>
          <Permission permission={VEHICLE_REMOVE}>
            <div className={styles.containerButton}>
              <Button className={styles.buttonDelete} warning onClick={this.handleDelete}>
                Delete
              </Button>
            </div>
          </Permission>
        </Card>
        <Permission permission={DEP_IT}>
          <VehicleRecommendationCard vehicle={this.props.vehicle} />
        </Permission>
      </>
    );
  }

  renderProductInvoiceCard() {
    if (this.props.workInvoices) return <Loader small />;

    return (
      <VehicleOutgoingProductInvoiceCard
        vehicleId={this.props.vehicle.id}
        vehicle={this.props.vehicle}
        invoiceId={this.state.outgoingProductInvoiceId}
      />
    );
  }

  render() {
    const vehicle = this.props.vehicle;
    const params = new URLSearchParams(window.location.search);
    const showLinktree = params.get('showLinkTree') === 'yes' || window.innerWidth <= 1280;

    // if (this.props.work) return <Loader small />;
    return (
      <Container className={styles.containerPage}>
        {this.state.showPdfPreview && (
          <PdfPreview onClose={() => this.setState({ showPdfPreview: false })} vehicle={vehicle} />
        )}
        {this.state.showNewAndNotUsed && (
          <NewAndNotUsed onClose={() => this.setState({ showNewAndNotUsed: false })} vehicle={vehicle} />
        )}

        {this.state.showSaleAgreementPdfPreview && (
          <SaleAgreementPdfPreview onClose={() => this.setState({ showSaleAgreementPdfPreview: false })} vehicle={vehicle} />
        )}
        {this.state.showCopyVehicleModal && (
          <CopyVehicleModal onClose={() => this.setState({ showCopyVehicleModal: false })} vehicle={vehicle} />
        )}
        <VBox left className={cn('col', styles.firstColumn)} top>
          {showLinktree && (
            <Card className="vehicle-info-card info-card misc">
              <h2 className="card-title mb-2 text-muted">{this.lbl('vehicle.linktree.quick_links')}</h2>
              <Permission permission={VEHICLE_EDIT}>
                {this.renderActionModal()}
                {vehicle.task_test_drive == '0' && vehicle.state_ac == null ? (
                  <div className={styles.containerButton}>
                    <Button
                      className={styles.buttonDelete}
                      warning
                      onClick={() => {
                        if (window.confirm('Weet je het zeker?')) {
                          this.props.setValueTestDriveAllClear('1');
                        }
                      }}
                    >
                      {this.lbl('vehicle.linktree.no_testdrive_task')}
                    </Button>
                  </div>
                ) : vehicle.state_ac == !null ? (
                  <div className={styles.containerButton}>
                    <Button className={styles.buttonDelete} warning>
                      {this.lbl('vehicle.linktree.testdrive_allready done')}
                    </Button>
                  </div>
                ) : (
                  <div className={styles.containerButton}>
                    <Button
                      className={styles.button}
                      onClick={() => {
                        if (window.confirm('Weet je het zeker?')) {
                          this.props.setValueTestDriveAllClear('1');
                        }
                      }}
                    >
                      {this.lbl('vehicle.linktree.testdrive_all_clear')}
                    </Button>
                  </div>
                )}
                {vehicle.location_address_id == '5' ? (
                  <div className={styles.containerButton}>
                    <Button className={styles.button} onClick={() => this.props.setValueLocationAddress('15700')}>
                      {this.lbl('vehicle.linktree.zet_naar_lippestraat')}
                    </Button>
                  </div>
                ) : vehicle.location_address_id == '15700' ? (
                  <div className={styles.containerButton}>
                    <Button className={styles.button} onClick={() => this.props.setValueLocationAddress('5')}>
                      {this.lbl('vehicle.linktree.zet_naar_kleefstraat')}
                    </Button>
                  </div>
                ) : (
                  <>
                    <div className={styles.containerButton}>
                      <Button className={styles.button} onClick={() => this.props.setValueLocationAddress('15700')}>
                        {this.lbl('vehicle.linktree.zet_naar_lippestraat')}
                      </Button>
                    </div>
                    <div className={styles.containerButton}>
                      <Button className={styles.button} onClick={() => this.props.setValueLocationAddress('5')}>
                        {this.lbl('vehicle.linktree.zet_naar_kleefstraat')}
                      </Button>
                    </div>
                  </>
                )}
                {vehicle.transport_outgoing_assigned_to != null && vehicle.transport_outgoing_done == null ? (
                  <div className={styles.containerButton}>
                    <Button
                      className={styles.button}
                      onClick={() => {
                        if (window.confirm('Are you sure?')) {
                          this.props.setValueTransportOutgoing();
                        }
                      }}
                    >
                      {this.lbl('vehicle.linktree.transport_outgoing_done')}
                    </Button>
                  </div>
                ) : vehicle.transport_outgoing_assigned_to == null ? (
                  <div className={styles.containerButton}>
                    <Button className={styles.buttonDelete} warning>
                      {this.lbl('vehicle.linktree.transport_outgoing_not_planned')}
                    </Button>
                  </div>
                ) : vehicle.transport_outgoing_done === '1' ? (
                  <div className={styles.containerButton}>
                    <Button className={styles.buttonDelete} warning>
                      {this.lbl('vehicle.linktree.transport_is_allready_done')}
                    </Button>
                  </div>
                ) : null}
                {vehicle.vehicle_purpose == 'commercial' && vehicle.import == '1' && !vehicle.task_popnagels ? (
                  <div className={styles.containerButton}>
                    <Button
                      className={styles.button}
                      onClick={() => {
                        if (window.confirm('Popnagels afronden en €15 kosten opvoeren?')) {
                          this.props.setValuePopnagels();
                        }
                      }}
                    >
                      {this.lbl('vehicle.linktree.popnagels_afronden')}
                    </Button>
                  </div>
                ) : vehicle.task_popnagels == '1' ? (
                  <div className={styles.containerButton}>
                    <Button className={styles.buttonDelete} warning>
                      {this.lbl('vehicle.linktree.popnagels_afgerond')}
                    </Button>
                  </div>
                ) : null}
              </Permission>
            </Card>
          )}
          <VehicleInfoCard vehicle={this.props.vehicle} />
          <VehicleDataCard vehicle={this.props.vehicle} />
          {window.innerWidth > 768 && (
            <>
              <VehicleDataConsumptionCard vehicle={this.props.vehicle} />

              <VehicleRDWandHistoryDataCard vehicle={this.props.vehicle} />
              <DebitorVehicleCard vehicle={this.props.vehicle} />

              <Permission permission={INVOICES_PAGE}>
                {this.state.showOutgoingInvoiceCard ? <VehicleOutgoingInvoiceCard vehicle={this.props.vehicle} /> : null}
              </Permission>
            </>
          )}

          {window.innerWidth <= 768 && (
            <>
              <Permission permission={INVOICES_PAGE}>
                <VehicleFinancePurchaseCard vehicle={this.props.vehicle} />
              </Permission>
              {this.props.workRemarks ? (
                <Loader small />
              ) : (
                <VehicleRemarksCard vehicle={this.props.vehicle} loggedUserId={this.props.loggedInUserId} />
              )}
              <Permission
                permission={[DEP_FINANCE, DEP_COMMERCE, DEP_ADMINISTRATION, DEP_ADMIN, DEP_IT, DEP_WORKSHOP, DEP_WALSTREET]}
              >
                {this.props.workVehicle ? (
                  <LoadingDetailsPageCard />
                ) : (
                  <VehicleFinanceSalesCard vehicle={this.props.vehicle} />
                )}
              </Permission>
              <Card className={cn('vehicle-info-card info-card data wide', styles.card)} style={{ width: '100%' }}>
                {this.props.workTransportOrder ? (
                  <Loader small />
                ) : (
                  <VehicleTransportOrderCard vehicle={this.props.vehicle} />
                )}
              </Card>
              {this.props.workTask ? (
                <LoadingDetailsPageCard />
              ) : (
                <VehicleTasksCard vehicle={this.props.vehicle} onAdded={this.setOutgoingProductInvoiceCardData.bind(this)} />
              )}
              {/* <VehicleProductTasksSection
                vehicleId={this.props.vehicle?.id}
                onAdded={this.setOutgoingProductInvoiceCardData.bind(this)}
              /> */}

              <Permission
                permission={[
                  DEP_FINANCE,
                  DEP_COMMERCE,
                  DEP_ADMINISTRATION,
                  DEP_ADMIN,
                  DEP_IT,
                  DEP_WORKSHOP,
                  VEHICLE_EXTRA_COSTS_CRUD,
                ]}
              >
                <VehicleExtraCostCard vehicle={this.props.vehicle} loggedUserId={this.props.loggedInUserId} />
              </Permission>

              <Permission
                permission={[DEP_FINANCE, DEP_COMMERCE, DEP_ADMINISTRATION, DEP_ADMIN, DEP_IT, DEP_WORKSHOP, DEP_WALSTREET]}
              >
                <Card className={cn('vehicle-info-card info-card data wide', styles.card)} style={{ width: '100%' }}>
                  <EditVehicleOptions photoBlock vehicle={this.props.vehicle} />
                </Card>
              </Permission>
              <VehicleInspectionCard vehicle={this.props.vehicle} />

              <Permission
                permission={[DEP_FINANCE, DEP_COMMERCE, DEP_ADMINISTRATION, DEP_ADMIN, DEP_IT, DEP_WORKSHOP, DEP_WALSTREET]}
              >
                <VehicleOptionsCard vehicle={this.props.vehicle} />
              </Permission>

              <Permission permission={INVOICES_PAGE}>
                {this.state.showOutgoingInvoiceCard ? <VehicleOutgoingInvoiceCard vehicle={this.props.vehicle} /> : null}
              </Permission>
              {/* <Permission
                permission={[
                  DEP_FINANCE,
                  DEP_COMMERCE,
                  DEP_ADMINISTRATION,
                  DEP_ADMIN,
                  DEP_IT,
                  DEP_WORKSHOP,
                  DEP_WALSTREET,
                  DEP_TRANSPORT,
                  INVOICES_PAGE,
                ]}
              >
                <VehicleLocationCard vehicle={this.props.vehicle} />
              </Permission>
              */}

              <Permission permission={[DEP_COMMERCE, DEP_ADMINISTRATION, DEP_ADMIN, DEP_IT]}>
                <VehicleWebsiteCard vehicle={this.props.vehicle} />
              </Permission>

              {/* <Permission permission={[DEP_FINANCE, DEP_COMMERCE, DEP_ADMINISTRATION, DEP_ADMIN, DEP_IT]}>
                <VehicleCardCounters vehicle={this.props.vehicle} />
              </Permission> */}

              <Permission permission={[DEP_FINANCE, DEP_COMMERCE, DEP_ADMINISTRATION, DEP_ADMIN, DEP_IT, DEP_WORKSHOP]}>
                <VehicleClaimCard vehicle={this.props.vehicle} />
              </Permission>

              <Permission permission={[DEP_COMMERCE, DEP_ADMINISTRATION, DEP_ADMIN, DEP_IT]}>
                <VehicleBpmCard vehicle={this.props.vehicle} />
              </Permission>

              <Permission permission={[DEP_COMMERCE, DEP_ADMINISTRATION, DEP_ADMIN, DEP_IT]}>
                <VehicleDataConsumptionCard vehicle={this.props.vehicle} />
              </Permission>
            </>
          )}
          {window.innerWidth > 768 && window.innerWidth < 1400 && this.renderThirdColumn(this.props.vehicle)}
        </VBox>
        <VBox left className="col" top>
          {this.state.outgoingProductInvoiceId && this.renderProductInvoiceCard()}
          {window.innerWidth > 768 && (
            <>
              <Wrapper>
                <VBox top>
                  <Permission permission={INVOICES_PAGE}>
                    <VehicleFinancePurchaseCard vehicle={this.props.vehicle} />
                  </Permission>

                  <VehicleExtraCostCard vehicle={this.props.vehicle} loggedUserId={this.props.loggedInUserId} />
                  <VehicleTasksCard
                    vehicle={this.props.vehicle}
                    onAdded={this.setOutgoingProductInvoiceCardData.bind(this)}
                  />
                  {/* <VehicleProductTasksSection
                    vehicleId={this.props.vehicle?.id}
                    onAdded={this.setOutgoingProductInvoiceCardData.bind(this)}
                  /> */}

                  {this.props.workRemarks ? (
                    <Loader small />
                  ) : (
                    <VehicleRemarksCard vehicle={this.props.vehicle} loggedUserId={this.props.loggedInUserId} />
                  )}
                   <VehicleTasksRemarksCard vehicle={this.props.vehicle} />


                </VBox>
                <VBox top>
                  {this.props.workVehicle ? (
                    <LoadingDetailsPageCard />
                  ) : (
                    <VehicleFinanceSalesCard vehicle={this.props.vehicle} />
                  )}

                  {/* <VehicleCardCounters vehicle={this.props.vehicle} /> */}

                  <VehicleWebsiteCard vehicle={this.props.vehicle} />

                  <VehicleClaimCard vehicle={this.props.vehicle} />
                  {/* <VehicleTransportCard vehicle={this.props.vehicle} /> */}
                  <VehicleBpmCard vehicle={this.props.vehicle} />
                </VBox>
              </Wrapper>
              <Card className={cn('vehicle-info-card info-card data wide', styles.card)} style={{ width: '100%' }}>
                {this.props.workTransportOrder ? (
                  <Loader small />
                ) : (
                  <VehicleTransportOrderCard vehicle={this.props.vehicle} />
                )}
              </Card>
              <Card className={cn('vehicle-info-card info-card data wide', styles.card)} style={{ width: '100%' }}>
                <EditVehicleOptions photoBlock vehicle={this.props.vehicle} />
              </Card>

              <VehicleOptionsCard vehicle={this.props.vehicle} />

              <Permission
                permission={[
                  DEP_COMMERCE,
                  DEP_WALSTREET,
                  DEP_ADMINISTRATION,
                  DEP_ADMIN,
                  DEP_IT,
                  DEP_WORKSHOP,
                  VEHICLE_INSPECTION_CRUD,
                ]}
              >
                <VehicleInspectionCard vehicle={this.props.vehicle} />
              </Permission>

              <Permission permission={INVOICES_PAGE}>
                <Card className={cn('vehicle-info-card-fin info-card-fin data wide', styles.card)} style={{ width: '100%' }}>
                  <VehicleInvoicesCard vehicle={this.props.vehicle} />
                </Card>
              </Permission>
            </>
          )}
        </VBox>

        {window.innerWidth > 1400 && (
          <VBox left className={cn('col align-items-end', styles.thirdColumn)} top>
            {this.renderThirdColumn(this.props.vehicle)}
          </VBox>
        )}

        {window.innerWidth < 748 && (
          <VBox left className={cn('col align-items-end', styles.thirdColumn)} top>
            {this.renderThirdColumn(this.props.vehicle)}
          </VBox>
        )}
      </Container>
    );
  }
}

VehicleDetailsColumnsComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    //  work: selectWorks([REQUEST_VEHICLE_INVOICES]),
    workVehicle: selectWork(REQUEST_VEHICLE),
    workRemarks: selectWork(`${REQUEST_VEHICLE_PROPERTY_UPDATE}-remarks`),
    workTaskRemarks: selectWork(`${REQUEST_VEHICLE_PROPERTY_UPDATE}-taskRemarks`),
    workTask: selectWork(REQUEST_VEHICLE_TASKS),
    workTransportOrder: selectWorks([
      REQUEST_TRANSPORT_ORDER_FILTER,
      APPLY_TRANSPORT_ORDER_FILTERS,
      REQUEST_TRANSPORT_ORDERS,
      REQUEST_VEHICLE_ADD_TO_OUTGOING_ORDER,
      REQUEST_VEHICLE,
    ]),
    loggedInUserId: selectUserId(),
    //creditorCompany: selectCompany(getPropByName(ownProps.vehicle, 'creditor_company')),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setVehicleProperty(name, value, callback) {
      if (value === null || value === undefined) {
        dispatch(deleteVehicleProperty(ownProps.vehicle.id, name));
      } else {
        dispatch(setVehicleProperty(ownProps.vehicle.id, name, value));
      }
    },
    deleteVehicle(callback) {
      dispatch(deleteVehicle(ownProps.vehicle.id, callback));
    },
    downloadImages(callback) {
      dispatch(downloadImages(ownProps.vehicle.id, callback));
    },
    fetchVehicleInvoices() {
      dispatch(fetchVehicleInvoices(ownProps.vehicle?.id));
    },
    print() {
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'label_printer_queue', '1'));
    },
    fetchVehicleTasks(callback) {
      dispatch(fetchVehicleTasks(ownProps.vehicle?.id, callback));
    },
    setValueLocationAddress(val) {
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'location_address_id', val));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'location_company_id', '4'));
      // window.location.reload();
    },
    setValueTransportOutgoing() {
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'transport_outgoing_initiated', '0'));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'transport_outgoing_done', '1'));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'transport_outgoing_assigned_to', null));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'transport_outgoing_completed_date', 'date_today'));
      // window.location.reload();
    },
    setValuePopnagels() {
      let extra_cost_popnagels_sum = Number(ownProps.vehicle?.extra_cost_popnagels) + 15;
      let extra_cost_sum = Number(ownProps.vehicle?.extra_cost_sum) + 15;
      let extra_cost_economic_prize_sum = Number(ownProps.vehicle?.economic_prize) + 15;

      dispatch(setVehicleProperty(ownProps.vehicle.id, 'task_popnagels', '1'));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'extra_cost_popnagels', extra_cost_popnagels_sum));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'extra_cost_sum', extra_cost_sum));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'economic_prize', extra_cost_economic_prize_sum));
    },
    setValueTestDriveAllClear(val) {
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'state_engine_general', '1'));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'state_ac', '1'));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'state_brakes', '1'));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'state_transmission', '1'));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'state_electrics', '1'));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'state_drive', '1'));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'task_test_drive', '0'));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'task_test_drive_done', '1'));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleDetailsColumns = compose(withConnect, withRouter)(VehicleDetailsColumnsComp);
